/**
 * HUD chrome (idea #1) — scanline overlay + a tiny ticking sub-display
 * in the bottom-right. Sits beneath all interactive layers; pointer
 * events disabled. The corner brackets are already provided by
 * MainPage's HudCorner; this layer adds the texture + the readout.
 */
import { useEffect, useState } from 'react';

export default function HUDChrome() {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      aria-hidden
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 4,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'repeating-linear-gradient(0deg, rgba(0,212,255,0.025) 0px, rgba(0,212,255,0.025) 1px, transparent 1px, transparent 3px)',
          mixBlendMode: 'screen',
          opacity: 0.5,
        }}
      />
      <div
        style={{
          position: 'absolute',
          right: 70,
          bottom: 8,
          fontFamily: "'Science Gothic', ui-monospace, monospace",
          fontSize: 8,
          color: 'rgba(0,212,255,0.45)',
          letterSpacing: '0.22em',
        }}
      >
        T+{String(tick % 10000).padStart(4, '0')} · UPTIME
      </div>
    </div>
  );
}
